import { useTranslation } from 'react-i18next'

import { Icon, Text, useWizardContext } from '@lounge-fe/ui-kit'
import { ProgressProps } from './types'

export const Progress = ({ isComplete }: ProgressProps) => {
  const { t } = useTranslation()
  const { steps, activeStep, totalSteps } = useWizardContext()

  const step = steps[activeStep]

  if (!step || activeStep === 0) {
    return null
  }

  return (
    <div className="sticky w-full flex flex-col gap-y-2 items-center bottom-0 md:absolute md:left-1/2 md:-translate-x-1/2 md:bottom-[10%] md:w-fit bg-white rounded-sm shadow-2 px-6 py-4">
      <div className="w-full flex justify-between">
        <Text
          variant="body-sm"
          className="text-action-primary-hovered capitalize"
        >
          {t('fitting_room.your_current_fit')}
        </Text>
        <Text
          variant="body-sm"
          className="text-action-primary-hovered capitalize"
        >
          {t('fitting_room.your_lounge_fit')}
        </Text>
      </div>
      <div className="flex gap-x-3 items-center">
        <span className="w-5 h-5 rounded-circle border-2 border-black" />
        <div className="flex gap-x-2">
          {Array.from({ length: totalSteps - 1 }).map((_, i) => (
            <span
              key={i}
              className={`block h-[2px] w-4 ${
                activeStep >= i + 1
                  ? 'bg-inverse'
                  : 'bg-background-primary-pressed'
              }`}
            />
          ))}
        </div>
        {isComplete ? (
          <Icon.Tick />
        ) : (
          <span className="w-5 h-5 rounded-circle border-2 border-background-primary-pressed" />
        )}
      </div>
    </div>
  )
}
